// id_ID language file
// Generated from Feishu Bitable
// Total entries: 450

export default{
    "game_diamond": {
        "title": "Info Berlian Game",
        "title0_title": "Cara Mendapatkan Berlian Game",
        "title0": {
            "txt1": "1. Mendapatkannya melalui tugas atau acara tertentu.",
            "txt2": "2. Tidak dapat dibeli dengan isi ulang."
        },
        "title1_title": "Penggunaan Berlian Game",
        "title1": {
            "txt1": "1. Hanya digunakan untuk permainan.",
            "txt2": "2. Di dalam game, Berlian Game berfungsi sama seperti berlian biasa dan dapat langsung digunakan. Berlian yang diperoleh dengan Berlian Game adalah berlian biasa.",
            "txt3": "3. Berlian permainan digunakan terlebih dahulu.",
            "txt4": "4. Dapat dikombinasikan dengan berlian. Misalnya, jika Anda memiliki 200 Berlian Game dan 800 Berlian, menggunakan 1000 akan menghabiskan keduanya."
        },
        "title2_title": "Validitas Berlian Game",
        "title2": {
            "txt1": "1. Berlaku untuk waktu terbatas dan akan diklaim kembali setelah habis masa berlakunya."
        }
    },
    "guanxi_gift_rule_title": "Deskripsi Hadiah",
    "guanxi_gift_rule_1": "Setelah mengirimkan hadiah hubungan, penerima dapat memilih untuk menjalin hubungan dengan Anda. Hanya satu hubungan yang dapat terjalin antara dua orang dalam satu waktu.",
    "guanxi_gift_rule_2": "Setiap orang dapat memiliki hingga 3 hubungan, dan jenis hubungannya bisa sama.",
    "guanxi_gift_rule_3": "Anda dapat mengakhiri hubungan 24 jam setelah terbentuk. Setelah mengakhiri hubungan, Anda dapat memulai hubungan baru setelah 24 jam berikutnya.",
    "not_exist": "Tidak ditemukan",
    "mbti_intro_title": "Deskripsi MBTI",
    "mbti_intro_pers": "Ciri-ciri Kepribadian",
    "mbti_intro_love": "Sifat Romantis",
    "mbti_intro_istj_pers": "Kepribadian Inspektur",
    "mbti_intro_istj_feature": "Serius, pendiam, berorientasi pada detail, dan teliti, mereka lebih menyukai kehidupan yang teratur dan terstruktur. Dapat diandalkan dan bertanggung jawab, mereka menaati aturan dan tradisi.",
    "mbti_intro_istj_love": "Dalam hal percintaan, ISTJ adalah pasangan yang setia dan stabil. Mereka menganggap serius hubungan, berfokus pada komitmen dan tanggung jawab, menunjukkan kepedulian mereka melalui tindakan alih-alih kata-kata, dan membutuhkan waktu untuk membangun hubungan yang mendalam.",
    "mbti_intro_isfj_pers": "Kepribadian Pengasuh",
    "mbti_intro_isfj_feature": "Lembut, baik hati, dan empati, mereka memperhatikan kebutuhan orang lain dan sabar. Berorientasi pada detail, mereka pendengar dan pendukung yang hebat.",
    "mbti_intro_isfj_love": "Dalam hubungan, ISFJ sangat peduli, memperhatikan detail kehidupan pasangannya, dan menciptakan suasana yang nyaman dan hangat. Meskipun cenderung tradisional, mereka mungkin membutuhkan waktu untuk berkomitmen, tetapi sangat setia setelah berkomitmen.",
    "mbti_intro_infj_pers": "Kepribadian Arsitek",
    "mbti_intro_infj_feature": "Berwawasan luas dan kreatif, dengan pemahaman mendalam tentang kemanusiaan dan masa depan. Mereka memiliki kehidupan batin yang kaya, bijaksana, dan analitis.",
    "mbti_intro_infj_love": "INFJ mencari koneksi mental dan emosional dengan pasangan, menghargai percakapan yang mendalam. Mereka memiliki cita-cita tinggi dalam cinta dan, ketika jatuh cinta, fokus dan berdedikasi.",
    "mbti_intro_intj_pers": "Kepribadian Komandan",
    "mbti_intro_intj_feature": "Logis, tenang, dan percaya diri dengan keterampilan analitis dan pengambilan keputusan yang kuat, mereka menghargai pengetahuan dan kebijaksanaan dan mengejar tujuan dengan gigih.",
    "mbti_intro_intj_love": "Dalam hubungan, INTJ mendekati cinta secara rasional, menghargai keyakinan dan tujuan bersama. Meskipun menahan emosi, mereka menunjukkan kepedulian melalui tindakan yang bijaksana.",
    "mbti_intro_istp_pers": "Kepribadian Pengrajin",
    "mbti_intro_istp_feature": "Praktis, jeli, dan analitis, mereka menikmati tugas langsung dan memecahkan masalah praktis, terutama di bidang mekanik atau teknis.",
    "mbti_intro_istp_love": "ISTP bersifat spontan dan berjiwa bebas dalam hubungan, menikmati momen saat ini bersama pasangannya, dan berbagi kesenangan hidup tanpa banyak batasan.",
    "mbti_intro_isfp_pers": "Kepribadian Seniman",
    "mbti_intro_isfp_feature": "Sensitif, lembut, dan artistik, mereka mengutamakan pengalaman emosional dan sensorik, sering mengekspresikan diri melalui bentuk-bentuk kreatif.",
    "mbti_intro_isfp_love": "Dalam hubungan, ISFP romantis dan penuh perhatian, terampil menciptakan suasana yang menawan, dan sering kali menyenangkan pasangannya dengan kejutan. Mereka bisa emosional dan membutuhkan pasangan yang memahami dan mendukung mereka.",
    "mbti_intro_infp_pers": "Kepribadian Mediator",
    "mbti_intro_infp_feature": "Idealis, baik hati, dan empati, mereka memiliki kehidupan batin yang kaya dan pemahaman kuat tentang sifat manusia, menghargai harmoni dan keindahan.",
    "mbti_intro_infp_love": "INFP berinvestasi dalam hubungan, mencari ikatan emosional yang kuat. Mereka menghargai pertukaran emosional dan berbagi pandangan penuh harapan tentang cinta.",
    "mbti_intro_intp_pers": "Kepribadian Ahli Logika",
    "mbti_intro_intp_feature": "Analitis dan ingin tahu, mereka memiliki keinginan kuat untuk mengetahui sesuatu, menjelajahi area yang tidak diketahui untuk mencari kebenaran.",
    "mbti_intro_intp_love": "Dalam hubungan, INTP bersifat logis, berfokus pada kecocokan intelektual dan emosional. Meskipun mereka mungkin tertutup dalam mengungkapkan perasaan, mereka menggunakan diskusi untuk menumbuhkan saling pengertian.",
    "mbti_intro_estp_pers": "Kepribadian Wirausahawan",
    "mbti_intro_estp_feature": "Energik, supel, dan suka berpetualang, mereka menikmati interaksi sosial dan pengambilan risiko, serta memanfaatkan peluang secara aktif.",
    "mbti_intro_estp_love": "Dalam hubungan, ESTP bersemangat dan penuh gairah, senang menjelajahi pengalaman baru bersama pasangannya. Mereka lugas dan terbuka dalam mengungkapkan pikiran dan perasaan mereka.",
    "mbti_intro_esfp_pers": "Kepribadian Penampil",
    "mbti_intro_esfp_feature": "Ramah, optimis, dan ekspresif, mereka gemar bersosialisasi dan hiburan, membawa energi dan antusiasme.",
    "mbti_intro_esfp_love": "Dalam percintaan, ESFP adalah pasangan yang lincah dan gemar melakukan aktivitas sosial bersama, menekankan perasaan dan pengalaman saat ini, serta menghadirkan kegembiraan dan kegembiraan bagi pasangannya.",
    "mbti_intro_enfp_pers": "Kepribadian Juru Kampanye",
    "mbti_intro_enfp_feature": "Kreatif, energik, dan hangat, mereka suka berinteraksi dengan orang lain dan sangat memahami emosi orang lain.",
    "mbti_intro_enfp_love": "ENFP bagaikan sinar matahari dalam hubungan, menghadirkan kehangatan dan kebahagiaan bagi pasangannya. Penuh romansa, mereka aktif mengungkapkan cinta dan berharap dapat menciptakan kenangan indah bersama.",
    "mbti_intro_entp_pers": "Kepribadian Debater",
    "mbti_intro_entp_feature": "Cerdas, jenaka, dan ingin tahu, mereka senang berdebat dan mengeksplorasi ide serta subjek baru.",
    "mbti_intro_entp_love": "ENTP terlibat dalam diskusi dan debat mendalam dengan pasangan, menikmati tantangan dan pertumbuhan intelektual dalam cinta. Seringkali ceria, mereka menghadirkan humor dalam hubungan.",
    "mbti_intro_estj_pers": "Kepribadian Eksekutif",
    "mbti_intro_estj_feature": "Praktis, tegas, dan percaya diri, dengan keterampilan organisasi dan kepemimpinan yang kuat, mereka mengutamakan efisiensi dan hasil.",
    "mbti_intro_estj_love": "Dalam hal percintaan, ESTJ tegas dan penuh tekad, aktif mengejar minat mereka dan merencanakan masa depan. Mereka menunjukkan kasih sayang melalui dukungan dan tindakan nyata.",
    "mbti_intro_esfj_pers": "Kepribadian Konsul",
    "mbti_intro_esfj_feature": "Ramah dan hangat, mereka berjiwa sosial dan peduli terhadap orang lain, menghargai tradisi dan ikatan kekeluargaan.",
    "mbti_intro_esfj_love": "ESFJ adalah pasangan yang penuh perhatian dan suportif, menciptakan lingkungan romantis yang harmonis dan hangat. Seringkali tradisional, mereka menghargai kebiasaan berpacaran yang akrab dan persetujuan keluarga.",
    "mbti_intro_enfj_pers": "Kepribadian Protagonis",
    "mbti_intro_enfj_feature": "Karismatik dan percaya diri, mereka mudah terhubung dan berkomunikasi dengan baik, memahami dan membimbing orang lain secara efektif.",
    "mbti_intro_enfj_love": "ENFJ adalah pasangan yang antusias dan romantis, mengekspresikan cinta mereka secara terbuka dan menciptakan suasana yang hangat. Mereka menghargai pertukaran emosi dan bertujuan untuk membangun ikatan yang erat dengan pasangannya.",
    "mbti_intro_entj_pers": "Kepribadian Eksekutif",
    "mbti_intro_entj_feature": "Logis, percaya diri, dan bersemangat, dengan kepemimpinan yang kuat dan kemampuan mengambil keputusan, mereka menghargai keunggulan dan kesuksesan, memegang standar tinggi untuk diri mereka sendiri dan orang lain.",
    "mbti_intro_entj_love": "Dalam percintaan, ENTJ berorientasi pada tujuan, memilih pasangan yang sepemikiran dan mendukung pertumbuhan bersama. Mereka memprioritaskan kompetensi dan ambisi bersama, serta mempererat hubungan melalui tujuan bersama.",
    "expressProposalWall": "Aturan Dinding Proposal",
    "expressHowTo": "Cara masuk ke Dinding Proposal",
    "expressSend": "Kirimkan hadiah lamaran kepada kekasih Anda dan teks ungkapan cinta Anda akan ditampilkan di Dinding Lamaran.",
    "expressSend1": "1. Ketuk \"Lamaran Sekarang\", Anda dapat melompat ke pesta dan memilih pengguna untuk mengirim kata-kata cinta Anda.",
    "expressSend2": "2. Pilih hadiah dan masukkan kata-kata yang ingin Anda katakan kepadanya di kartu.",
    "expressSend3": "3. Ketuk untuk mengirim hadiah dan kartu lamaran Anda akan ditampilkan di dinding.",
    "expressDifferent": "Berbagai Jenis Hadiah Lamaran",
    "expressWeHave": "Kami memiliki 4 jenis Hadiah Proposal sebagai berikut.",
    "expressWeHave1": "1. Kartu Hadiah Proposal Dasar: Latar belakang warna sederhana.",
    "expressWeHave2": "2. Kartu Hadiah Proposal Dekorasi: Latar belakang warna-warni yang dekoratif.",
    "expressWeHave3": "3. Kartu Hadiah Lamaran Mewah: Latar belakang dekoratif dengan efek mewah.",
    "expressWeHave4": "4. Kartu Hadiah Lamaran Cinta Sejati: Latar belakang dekoratif dengan efek mewah, dan dengan bilah notifikasi mewah di seluruh server.",
    "expressProposal": "Rentang Tampilan Kartu Proposal",
    "expressProposal1": "1. Dinding Lamaran di ruangan. (Ketuk bilah di atas hadiah lamaran)",
    "expressProposal2": "2. Dinding Proposal di sebelah halaman Momen.",
    "diamondDrop1": "1. Saat pengguna mengirimkan hadiah dengan total lebih dari 50.000 berlian di suatu ruangan (hadiah keberuntungan dihitung sebesar 0,1 kali nilainya), peti berlian akan dijatuhkan dan siapa pun di ruangan tersebut dapat membuka peti tersebut untuk mengambil berlian.",
    "diamondDrop2": "2. Setiap peti memiliki hitungan mundur 1 menit sebelum dapat dibuka.",
    "diamondDrop3": "3. Berlian dalam setiap peti terbatas; setelah hitungan mundur berakhir, Anda tidak dapat lagi mengklaim berlian dari peti tersebut.",
    "diamondDrop4": "4. Setelah peti tertutup, Anda dapat mengklik untuk melihat berapa banyak berlian yang Anda peroleh darinya.",
    "baoxaingxianding": "Batas Hadiah Harta Karun",
    "cancelAccount": {
        "accountRecoveryContent": "Selama masa pemulihan, Anda dapat masuk kembali menggunakan metode sebelumnya dan memilih untuk memulihkan akun Anda. Setelah dipulihkan, Anda akan mendapatkan kembali semua pesan, level, dan berlian akun Anda.",
        "accountRecoveryTitle": "Pemulihan Akun:",
        "confirmCancellation": "Apakah Anda yakin ingin menghapus?",
        "convalescenceContent": "Setelah mengirimkan permintaan penghapusan, akun Anda akan dinonaktifkan sementara selama 30 hari. Selama masa ini, semua informasi akun, level, dan berlian Anda akan disimpan, sehingga Anda dapat memulihkannya dengan mudah jika berubah pikiran.",
        "convalescenceTitle": "Periode Pemulihan:",
        "finalContent": "Jika Anda tidak memilih untuk memulihkan akun Anda sebelum akhir periode pemulihan (31 hari sejak permintaan penghapusan), akun Anda dan semua data terkait akan dihapus secara permanen. Harap diperhatikan bahwa setelah dihapus, akun dan data Anda tidak dapat dipulihkan.",
        "finalTitle": "Penghapusan Akhir:",
        "reserveContent": "Selama masa pemulihan, kami akan melindungi data akun Anda untuk memastikannya tidak hilang atau rusak.",
        "reserveTitle": "Retensi Data:",
        "statementContent": "Permintaan Penghapusan: Setelah Anda mengirimkan permintaan penghapusan akun, akun Anda akan memasuki \"masa pemulihan\" selama 30 hari. Selama masa ini, Anda dapat memilih untuk memulihkan akun kapan saja. Jika Anda merupakan bagian dari agensi, penghapusan akun tidak dapat dilakukan.",
        "statementTitle": "Pemberitahuan Penghapusan Akun:",
        "userContent": "Terima kasih telah menggunakan layanan kami. Kami memahami bahwa terkadang Anda mungkin perlu menghapus akun. Untuk memastikan keputusan Anda dipertimbangkan dengan matang dan memberikan kesempatan untuk pertimbangan ulang, kami menguraikan proses penghapusan akun dan ketentuan terkait di sini.",
        "userTitle": "Pengguna yang terhormat:"
    },
    "Countdown": "Hitung mundur",
    "Endactivity": "Acara Berakhir",
    "eventDetails": "Detail Acara",
    "eventGifts": "Hadiah Acara",
    "eventList": "Papan Peringkat Acara",
    "eventReward": "Hadiah Acara",
    "eventRewards": {
        "player": "Pemain Aktif Harian",
        "proportion": "Tingkat Pengembalian Hadiah",
        "title": "Hadiah Acara",
        "txt1": "1. Data dari hari sebelumnya dihitung setiap hari pada pukul 00:00 (UTC+8).",
        "txt2": "2. Hadiah diberikan berdasarkan jumlah peserta dan berlian aktual yang dihabiskan di ruangan (taruhan pengguna dikurangi kemenangan pengguna).",
        "txt3": "3. Data untuk minggu sebelumnya dihitung setiap Senin pukul 00:00 (UTC+8), dan hadiah didistribusikan dalam waktu 3 hari.",
        "txt4": "4. Tingkat Pengembalian Hadiah:",
        "txt5": "5. Definisi Pemain Aktif: Pemain yang bertaruh lebih dari 1.000 berlian dalam sehari."
    },
    "EventRules": "Aturan Acara",
    "Eventtime": "Waktu Acara",
    "guild": {
        "guild_certification01": "Verifikasi Agensi",
        "guild_certification02": "Selamat Datang Agensi",
        "guild_certification03": "Persyaratan Rekrutmen",
        "guild_certification04": [
            "Menyelesaikan 10 penandatanganan jangkar dan menetap dalam waktu satu minggu",
            "Mampu memberikan ID pimpinan agensi dan dokumen nama asli lainnya",
            "Berikan profil agensi, pengenalan tim, informasi jangkar, aturan penghasilan jangkar, dll."
        ],
        "guild_certification05": "Jika Anda memenuhi persyaratan di atas, kirimkan informasi Anda ke email resmi: billionairepte@gmail.com Setelah disetujui, seorang anggota staf akan menghubungi Anda.",
        "guild_certification06": "Disalin ke papan klip",
        "guild_certification07": "Kontak untuk Pertanyaan",
        "guild_certification08": "Menyalin",
        "guild_certification09": "Informasi Keanggotaan",
        "guild_certification10": [
            {
                "title": "1. Aturan Keanggotaan",
                "value": [
                    "Pelamar harus setuju dengan pimpinan agensi untuk mengajukan permohonan keanggotaan di platform. Setelah disetujui oleh pimpinan, mereka akan menjadi anggota tetap yang berkontribusi bagi agensi."
                ]
            },
            {
                "title": "2. Aturan Pengunduran Diri",
                "value": [
                    "Untuk meninggalkan agensi setelah bergabung, anggota harus menyetujui kesepakatan dengan pimpinan agensi. Klik \"Keluar dari Agensi\" di halaman profil agensi. Pimpinan agensi harus mengklik \"Setuju untuk Keluar\", lalu anggota akan keluar dari agensi.",
                    "Setelah penarikan berhasil, Anda dapat mengajukan permohonan untuk bergabung dengan agensi lain."
                ]
            }
        ],
        "guild_certification11": "Informasi Agensi",
        "guild_certification12": [
            {
                "title": "Pendapatan Agensi",
                "value": [
                    "Pengguna dan pembawa acara di ruang keluarga menerima hadiah, yang menghasilkan kontribusi agensi.",
                    "Serangan bos terjadi di ruang keluarga.",
                    "Pembawa acara yang menandatangani kontrak dengan agensi akan membuat ruang CP, dan menerima hadiah akan menghasilkan kontribusi agensi. (Pembawa acara yang tidak menandatangani kontrak tidak dapat membuat ruang CP dan menghasilkan kontribusi keluarga setelah bergabung dengan keluarga.)"
                ]
            }
        ],
        "InvitationCodeTitle": "Kode Undangan",
        "invite_rules_intriduction": "Aturan Undangan",
        "invite_rules_intriduction_content": [
            "Pembawa acara dapat mendaftar untuk bergabung dengan agensi Anda dan menjadi pembawa acara dengan memasukkan kode undangan selama pendaftaran.",
            "Pembawa acara yang tidak memasukkan kode undangan selama pendaftaran dapat mendaftar untuk bergabung dengan keluarga Anda melalui halaman keluarga, lalu mendaftar untuk menjadi pembawa acara."
        ]
    },
    "legend": {
        "title": "Februari yang Legendaris"
    },
    "officialMember": "Staf Resmi",
    "prettyNumber": {
        "text": "Ⅰ. Koleksi ID Khusus",
        "text1": "Setelah mencapai Noble Level 3 atau lebih tinggi, Anda dapat mengklaim ID Khusus yang sesuai dengan level Anda.",
        "text2": "Bangsawan tingkat tinggi dapat mengklaim ID Khusus tingkat rendah. Misalnya, Bangsawan Tingkat 6 dapat mengklaim ID Khusus Tingkat 3.",
        "text3": "Ketika status bangsawan Anda berakhir, ID Khusus juga tidak tersedia. Anda perlu mengaktifkan kembali status bangsawan Anda agar dapat terus menggunakan ID Khusus.",
        "text5": "Setelah Anda mengklaim ID Khusus, Anda tidak dapat menukarnya dengan nomor lain dengan level yang sama atau lebih rendah.",
        "text6": "Jika Anda mencapai level bangsawan yang lebih tinggi saat menggunakan ID Khusus, Anda dapat segera beralih ke ID Khusus level yang lebih tinggi, dan ID asli akan dikembalikan ke toko.",
        "text7": "Misalnya, pengguna Noble 4 yang awalnya mengklaim ID Khusus Noble 4 lalu meningkatkan ke Noble 6 tidak dapat beralih ke ID Khusus Noble 4 atau yang lebih rendah, tetapi dapat segera mengklaim ID Khusus Noble 6.",
        "title": "Penjelasan",
        "title1": "2. Kedaluwarsa ID Khusus",
        "title2": "3. Penggantian ID Khusus"
    },
    "reception": {
        "reception01": "Penjelasan Papan Peringkat Hadiah",
        "reception02": [
            {
                "title": "Apa itu Papan Peringkat Hadiah Kamar?",
                "value": [
                    "Papan Peringkat Hadiah Kamar adalah peringkat hadiah waktu nyata yang diterima di kamar",
                    "Jumlah hadiah kamar = Jumlah hadiah berlian"
                ]
            },
            {
                "title": "Bagaimana peringkat Papan Peringkat Hadiah Kamar?",
                "value": [
                    "Peringkat ditentukan berdasarkan total pendapatan semua kamar, dihitung secara komprehensif",
                    "Papan Peringkat Per Jam: Diatur ulang setiap jam pada UMT+8",
                    "Papan Peringkat Harian: Diatur ulang pada pukul 00:00 UMT+8 setiap hari"
                ]
            },
            {
                "title": "Teratas di Papan Peringkat Per Jam disiarkan ke seluruh server",
                "value": [
                    "1 ruangan teratas pada papan peringkat hadiah per jam diumumkan di semua ruang server"
                ]
            }
        ]
    },
    "roomParty": {
        "back": "Kembali",
        "event_rule": "<p>1. Papan Peringkat Durasi: Melacak total waktu yang dihabiskan pengguna di semua posisi mikrofon ruangan selama acara. 3 kontributor teratas di 3 ruangan teratas akan menerima hadiah.</p><p>2. Papan Peringkat Kedermawanan: Melacak total jumlah berlian yang diterima di ruangan selama acara. 3 pengguna berlian teratas di 3 ruangan teratas akan menerima hadiah.</p><p>3. Acara ini merupakan acara siklus mingguan, dengan papan peringkat yang diatur ulang dan dihitung ulang setiap minggu.</p>",
        "last_week": "Minggu lalu",
        "last_week_rank": "Detail Papan Peringkat Minggu Lalu",
        "reward": "Hadiah",
        "rich_rank": "Papan Peringkat Hadiah Kamar",
        "rule": "Aturan",
        "rule_reward": "Aturan & Hadiah",
        "time_rank": "Papan Peringkat Durasi",
        "title": "Ruang Keluarga",
        "top1": "TOP1",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_1_name": "Bingkai selama 14 hari",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/mount/thunder_armor.png?t=1666610955",
        "top1_pictures_2_name": "Efek selama 14 hari",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_3_name": "Bingkai selama 14 hari",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_4_name": "Bingkai selama 7 hari",
        "top2": "TOP2",
        "top3": "3 TERATAS"
    },
    "TopUpRewards": "Hadiah TopUp",
    "treasure_chest": {
        "title": "Petunjuk Hadiah Peti Harta Karun",
        "value1": "Ada tiga jenis peti harta karun: Kayu, Perak, dan Emas.",
        "value2": "Saat Anda membuka peti harta karun, Anda akan secara acak menerima hadiah dari peti tersebut dan mengirimkannya.",
        "value3": "Pengirim memperoleh poin pengalaman berdasarkan berlian yang dibelanjakan, sementara penerima menerima Koin dan poin pesona berdasarkan nilai hadiah dari peti.",
        "value4": "Peti Kayu, dihargai 1500 berlian, berisi hadiah berikut:",
        "value5": "Peti Perak, dengan harga 7500 berlian, berisi hadiah-hadiah berikut:",
        "value6": "Peti Emas, dengan harga 25000 berlian, berisi hadiah berikut:",
        "value7": "Hadiah peti harta karun hanya untuk hiburan dan interaksi sosial. Segala tindakan yang memengaruhi keadilan atau mengeksploitasi bug produk akan dilarang. Jika terdeteksi, platform akan memblokir akun tersebut dan berhak mengambil tindakan hukum."
    },
    "treasure_name": {
        "name1": "Peti Kayu",
        "name2": "Peti Perak",
        "name3": "Peti Emas",
        "name4": "Kemungkinan"
    },
    "Value": "Nilai:",
    "Webname": {
        "addUid": "Tambahkan UID",
        "balance": "Keseimbangan:",
        "Confirm": "Mengonfirmasi",
        "err_uid": "UID tidak valid, silakan masukkan kembali",
        "lang": "Pilih Bahasa",
        "Query": "Mencari",
        "recharge": "Pusat Isi Ulang",
        "Recharge": "Isi Ulang",
        "self": "Saluran",
        "uid": "Ubah UID",
        "uuserName": "Nama panggilan:",
        "Withdrawal": "Penarikan"
    },
    "Weekly_Cp": {
        "7days": "7 hari",
        "back": "Kembali",
        "countdown": "Hitung mundur ke minggu ini",
        "day": "Hari",
        "diamonds": "https://image.pocketliveapp.com/image/activity/New%20Folder/diamonds.png",
        "event_rule": "<p>Catatan</p><p>1. Semua hadiah akan dikreditkan ke akun Anda dalam 3-5 hari kerja setelah acara berakhir.</p><p>2. Papan peringkat menghitung jumlah berlian yang digunakan untuk mengirimkan hadiah acara kepada pengguna lain. 1 berlian = 1 poin CP, dan 3 pasangan CP teratas dengan poin CP tertinggi akan menerima hadiah acara.</p><p>3. Acara berakhir setiap Senin pukul 00:00 (UTC+8), dan nilai untuk minggu sebelumnya akan ditetapkan.</p><p>4. Hanya 10% dari berlian yang digunakan untuk hadiah keberuntungan yang akan dihitung.</p>",
        "gift": "Hadiah Acara",
        "hour": "Jam",
        "last_week": "Minggu lalu",
        "last_week_rank": "Daftar minggu lalu",
        "minute": "Menit",
        "pocketcoins": "https://image.pocketliveapp.com/image/activity/New%20Folder/coins.png",
        "reward": "Hadiah",
        "rule": "Aturan",
        "rule_reward": "Aturan & Hadiah",
        "seconds": "Detik",
        "title": "Belahan jiwa",
        "top1": "TOP1",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top1_pictures_1_name": "Bingkai Avatar Bintang Mingguan",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top1_pictures_2_name": "Bingkai Avatar Dukungan Terbaik",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/2011_cloth_female.png?t=1678879041",
        "top1_pictures_34_name": "Pakaian Bintang Mingguan",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/2010_suit_male.png?t=1678879038",
        "top2": "TOP2",
        "top2_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top2_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top3": "3 TERATAS",
        "top3_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top3_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top46": "4-6 TERATAS",
        "top710": "TOP7-10"
    },
    "Withdrawal": "Petunjuk Penarikan",
    "withdrawalInstructions": {
        "text1": "Fitur penarikan saat ini hanya tersedia di negara tertentu.",
        "text2": "Waktu yang dibutuhkan untuk memproses penarikan dapat bervariasi, tergantung pada saluran.",
        "text3": "Jumlah sebenarnya yang diterima mungkin sedikit lebih rendah dari jumlah yang ditampilkan karena fluktuasi nilai tukar dan biaya.",
        "text4": "Anda hanya dapat menarik dana satu kali per hari.",
        "text5": "Jika Anda mengalami masalah, silakan hubungi kami."
    },
    "withdrawalLogin": {
        "accountId": "ID akun Pix",
        "accountIdTips": "",
        "accountIdtsa": "ID akun Pix tidak boleh kosong",
        "accountType": "Jenis akun Pix",
        "code": "Kode verifikasi:",
        "Confirm": "Mengonfirmasi",
        "documentId": "Nomor ID pribadi",
        "documentIdTips": "",
        "documentIdtsa": "Tipe ID tidak boleh kosong",
        "documentType": "Jenis ID",
        "getAccount": "Dapatkan akun",
        "getUserId": "Silakan masukkan ID pengguna",
        "incorrectAccount": "Akun salah",
        "login": "Login",
        "loginSuccessful": "Login berhasil",
        "name": "Nama pengguna Pix",
        "nameTips": "",
        "nametsa": "Panjangnya harus antara 5 dan 100 karakter",
        "officialGroup": "Jika Anda memiliki pertanyaan, silakan hubungi dukungan resmi kami.",
        "pocket": "Saldo Koin Saku",
        "Pocket": "Saldo Koin Saku tidak mencukupi",
        "Send": "Mengirim",
        "text": "Kode verifikasi akan dikirim dalam aplikasi",
        "title": "Penarikan pendapatan",
        "title2": "Detail penarikan",
        "user_id": "ID Akun:",
        "Whatsapp": "Akun Whatsapp salah",
        "WhatsappTips": "",
        "applicationTime": "Tanggal Permintaan",
        "amount": "Jumlah Penarikan",
        "success": "Kesuksesan",
        "applicationSuccess": "Permintaan Telah Dikirim"
    },
    "top1AnchorRewards": "1 Hadiah Jangkar Teratas",
    "top2_3AnchorRewards": "2-3 Hadiah Jangkar Teratas",
    "top4_10AnchorRewards": "4-10 Hadiah Jangkar Teratas",
    "top1Icon7day": "Bingkai Avatar*7D",
    "top1_2Icon7day": "Efek Pintu Masuk*7D",
    "top3Icon7day": "Bingkai Avatar*7D",
    "top1VIPRewards": "1 Hadiah VIP Teratas",
    "top2_3VIPRewards": "2-3 Hadiah VIP Teratas",
    "top4_10VIPRewards": "4-10 Hadiah VIP Teratas",
    "relastionship": {
        "des": [
            "",
            "1. Setelah mengirimkan hadiah hubungan, pihak lain dapat memilih untuk menjalin hubungan dengan Anda. Hanya satu jenis hubungan yang dapat terjalin antara dua orang.",
            "2. Dalam 7 hari kalender (UTC+3) setelah hubungan terjalin, keintiman tidak akan menurun. Setelah masa perlindungan ini, jika keintiman tidak meningkat 50 poin dalam sehari, keintiman akan menurun 10% pada pukul 00:00 keesokan harinya (penurunan minimum adalah 1). Ketika keintiman mencapai 0, hubungan akan dibatalkan pada pukul 00:00 keesokan harinya. Jika keintiman tidak meningkat 50 poin selama 10 hari berturut-turut, hubungan akan otomatis berakhir pada pukul 00:00.",
            "3. Anda dapat mengakhiri hubungan 24 jam setelah terbentuk. Setelah mengakhirinya, Anda dapat membangun kembali hubungan 24 jam kemudian.",
            "4. Setiap orang memiliki 3 slot hubungan secara default. Anda dapat menggunakan berlian untuk membeli lebih banyak, setiap slot berharga 99.999 berlian, dan Anda dapat membeli hingga 10 slot. Anda juga dapat menambah slot dengan meningkatkan level VIP Anda.",
            "Tingkat VIP",
            "Total slot hubungan yang dapat diperluas"
        ]
    },
    "gift_album_des1": "Mengirim hadiah di atas dapat membantunya menyalakan Album Mingguan - \"Tur Dunia\" dan mendapatkan hadiah.",
    "gift_album_des2": "Mengirim hadiah di atas dapat membantunya menyalakan Album Permanen - \"Pusat Perhatian\" dan mendapatkan hadiah.",
    "gift_album_des3": "Mengirim hadiah di atas dapat membantunya menyalakan Album Permanen - \"Penjaga SVIP\" dan mendapatkan hadiah.",
    "gift_album_des4": "Mengirim hadiah di atas dapat membantunya menyalakan Album Permanen - \"Pernikahan Impian\" dan mendapatkan hadiah.",
    "gift_album_des5": "Buka [Profil] - [Dinding Hadiah] - [Album] untuk melihat detail",
    "gift_album_des8": "Mengirim hadiah di atas dapat membantunya menyalakan Koleksi Permanen - 'Pesta Ulang Tahun' dan mendapatkan hadiah.",
    "gift_album_des7": "Mengirim hadiah di atas dapat membantunya menyalakan Album Permanen - \"Bintang Ruangan\" dan mendapatkan hadiah.",
    "gift_harifata": "Burj Khalifa",
    "gift_sailing_hotel": "Burj Al Arab",
    "gift_mosque": "Masjid Agung",
    "gift_abatta": "Menara Abate",
    "gift_sphinx": "Sphinx",
    "svip_gift_1": "SVIP1",
    "svip_gift_2": "SVIP2",
    "svip_gift_3": "SVIP3",
    "svip_gift_4": "SVIP4",
    "svip_gift_5": "SVIP5",
    "svip_gift_6": "SVIP6",
    "gift_conf_lv1": "Detak Jantung Cinta",
    "gift_conf_lv2": "Cinta Tertabrak",
    "gift_conf_lv3": "Cinta Tak Terbatas",
    "gift_conf_lv4": "Tidak ada seorang pun kecuali kamu",
    "gift_habibi": "Habibi",
    "gift_bestie": "Sahabat",
    "gift_couple": "Pasangan",
    "gift_confidant": "Orang kepercayaan",
    "weding_gift_kiss": "Ciuman",
    "weding_gift_ring": "Cincin",
    "weding_gift_proposal": "Lamaran",
    "weding_gift_castle": "Kastil",
    "weding_gift_wedding_dress": "Gaun pengantin",
    "weding_gift_wedding": "Pernikahan",
    "gift_album_des6": "Aturan",
    "guild_can_with": "Tersedia",
    "guild_with_ing": "Diproses",
    "guild_self_withdraw": "Penarikan mandiri",
    "guild_transfer_to_leader": "Transfer ke Ketua Agensi",
    "guild_salary_to_reseller": "Transfer ke Reseller",
    "guild_convert_to_diamond": "Tukar ke Berlian",
    "guild_platform_settlement": "Penyelesaian platform",
    "guild_withdrawal_records": "Riwayat penarikan",
    "guild_current_withdrawable_pcoin": "Koin tersedia",
    "guild_transfer_pcoin_amount": "Jumlah transfer",
    "guild_all": "Semua",
    "guild_read_before_withdraw": "Baca sebelum penarikan:",
    "guild_withdraw_note_1": "Kirim",
    "guild_withdraw_note_2": "Koin untuk penarikan tidak cukup",
    "guild_min_withdraw_amount": "Konfirmasi kirim?",
    "guild_withdraw_note_4": "Batal",
    "guild_appeal_to_platform": "Konfirmasi",
    "guild_submit_application": "Metode penarikan",
    "guild_withdraw_below_min": "Penarikan ketua",
    "guild_confirm_submit_application": "Waktu pengajuan",
    "guild_freeze_notice": "Waktu pemrosesan",
    "guild_communicate_with_leader": "Alasan ditolak",
    "guild_cancel": "Jumlah dikembalikan",
    "guild_confirm": "Menunggu",
    "guild_withdrawal_method": "Selesai",
    "guild_leader_withdraw": "Ditolak",
    "guild_status_timeout_rejected": "Ditolak otomatis (waktu habis)",
    "guild_apply_time": "Hanya 3 bulan terakhir",
    "guild_process_time": "Ada pertanyaan penarikan?",
    "guild_rejection_reason": "Hubungi dukungan",
    "guild_amount_refunded": "Reseller terverifikasi",
    "guild_status_pending": "Khusus reseller",
    "guild_status_completed": "Tersedia",
    "guild_status_rejected": "Jumlah transfer",
    "guild_show_last_3_months": "Perkiraan masuk",
    "guild_withdrawal_question": "Berhasil",
    "guild_contact_customer_service": "Tukar ke Berlian",
    "guild_certified_reseller": "Koin tersedia untuk ditukar",
    "guild_not_reseller_cannot_transfer": "Tukar",
    "guild_current_withdrawable": "Ditukar",
    "guild_transfer_amount": "Koin terselesaikan",
    "guild_estimated_arrival": "Permintaan terkirim",
    "guild_read_before_operation": "1. Harap konfirmasi detail pembayaran offline dengan reseller terlebih dahulu",
    "guild_transfer_note_1": "2. Transfer hanya bisa ke reseller",
    "guild_transfer_note_2": "Konfirmasi transfer",
    "guild_confirm_transfer": "Konfirmasi kirim?",
    "guild_confirm_submit_transfer": "{n} koin akan dipotong",
    "guild_deduct_pcoin_receive_diamond": "Silakan koordinasikan detail pembayaran dengan reseller",
    "guild_communicate_with_reseller": "Transaksi berhasil",
    "guild_operation_success": "Tukar ke Berlian",
    "guild_exchange_diamond": "Koin tersedia untuk ditukar",
    "guild_current_exchangeable_pcoin": "Tukar",
    "guild_exchange": "Penukaran berhasil",
    "guild_exchange_success": "Koin menunggu penyelesaian",
    "guild_settlement_pcoin_amount": "1. Harap konfirmasi metode penarikan dengan tim Operasional terlebih dahulu",
    "guild_settlement_note_1": "2. Pembayaran akan diproses Senin depan",
    "guild_settlement_note_2": "3. Minimum penarikan: {n} koin",
    "guild_settlement_min_amount": "Permintaan terkirim",
    "guild_application_submitted": "{n} koin akan dipotong",
    "guild_deduct_pcoin": "Silakan koordinasikan detail pembayaran dengan tim Operasional",
    "guild_user_not": "Pengguna tidak ditemukan",
    "guild_please_enter_amount": "Masukkan jumlah",
    "guild_insufficient_balance": "Saldo tidak mencukupi",
    "guild_please_enter_reseller_uid": "Masukkan UID RESELLER",
    "guild_please_search_reseller_first": "Cari RESELLER terlebih dahulu",
    "guild_select_hand": "Pilih tindakan",
    "guild_ci_hand": "1. Tindakan ini akan mengajukan permintaan ke Ketua Guild,",
    "guild_offline_transfer_funds": "dan pembayaran akan dilakukan secara offline oleh ketua",
    "guild_ci_hand_2": "2. Harap konfirmasi metode pembayaran dengan ketua terlebih dahulu (kartu bank / USDT, dll.)",
    "guild_ci_hand_3": "3. Jumlah penarikan minimum adalah {n} Coins",
    "guild_ci_hand_4": "4. Jika ketua mengonfirmasi pembayaran tetapi Anda belum menerimanya, simpan riwayat chat dan",
    "guild_ci_hand_5": "ajukan banding ke platform",
    "guild_ci_hand_6": "Sistem akan membekukan {n} Coins hingga diproses oleh ketua",
    "guild_ci_hand_7": "Konfirmasikan jalur penarikan dengan ketua; pembayaran dilakukan offline",
    "guild_tips_1": "Coins yang dapat ditarik di bawah minimum",
    "guild_contact_service": "Silakan hubungi tim operasional untuk pengaturan pembayaran",
    "guild_reseller_tips": "Koin kamu sudah menjadi berlian milik pengguna lain. Silakan hubungi dia soal pembayaran.",
    "gift_collection_detail_permanent_birthday": "Pesta Ultah",
    "gift_collection_detail_permanent_roomstar": "Bintang Ruangan",
    "gift_holy_sword": "Pedang Suci",
    "gift_volcano": "Gunung Berapi",
    "gift_emperor_come_world": "Kaisar Eropa Datang ke Dunia",
    "gift_castle_of_love": "Istana Cinta",
    "gift_Immortal_god_war": "Dewa Perang Abadi",
    "gift_king_of_gods": "Raja Para Dewa",
    "birthday_gift_cybergift": "Hadiah Siber",
    "birthday_gift_wish": "Harapan Lampu",
    "birthday_gift_cake": "Kue Emas",
    "birthday_gift_lion": "Berkat Singa",
    "birthday_gift_biggift": "Hadiah Mewah",
    "guild_reseller_tips": "Koin kamu sudah menjadi berlian milik pengguna lain. Silakan hubungi dia soal pembayaran.",
    "guild_page_fee": "Biaya $2 per penarikan",
    "guild_page_saudi": "Arab Saudi",
    "guild_page_morocco": "Maroko",
    "guild_page_bank": "Bank",
    "guild_page_name": "Nama (Inggris)",
    "guild_page_name_english": "Nama harus dalam bahasa Inggris",
    "guild_page_bank_number": "Nomor rekening bank",
    "guild_page_enter": "Masukkan nomor rekening yang benar",
    "guild_page_address": "Alamat (Inggris)",
    "guild_page_address_english": "Alamat harus dalam bahasa Inggris",
    "guild_page_country": "Negara/Wilayah",
    "guild_page_holder_name": "Nama pemilik rekening",
    "guild_page_sa": "Contoh: SA8200000000XXXXXXXXXXXX",
    "guild_page_format": "Format: Jalan, Area, Kota, Provinsi, Negara",
    "guild_page_minimum": "3. Jumlah penarikan minimum adalah {n} Coins"
}
